import i18n from "../i18n.js";
import axios from "axios";
import { monitore } from "../components/helpers/helpers.js";

let mutations = {
  // GET profil from HelloID
  setLoggedUser(state, user) {
    state.user = user;
    // Add a console log to know expiring token
    let exp = user.expires_at.toString()
    console.log("TOKEN EXPIRATION : ", new Date(Number(exp + "000")))
    // set access token
    // console.log("ON PLACE LE TOKEN EN INTERCEPTORS AXIOS DEPUIS LE STORE");
    axios.interceptors.request.use(async (config) => {
      config.headers.common.Authorization = "Bearer " + user.id_token;
      return config;
    });
    try {
      state.identity.name = user.profile.name;
      state.identity.email = user.profile.email;
      state.identity.company = user.profile.OrganizationName;
      state.identity.current_date = Date.now();
      // id openid
      state.identity.sub = user.profile.sub;
    } catch (er) {
      state.identity.name = null;
      state.identity.email = null;
      state.identity.company = null;
      state.identity.id = null;
    }
  },

  // --------
  // USER
  // --------
  setName(state, name) {
    state.identity.name = name;
  },
  setEmail(state, email) {
    state.identity.email = email;
  },
  setUserId(state, id) {
    state.identity.id = id;
  },
  setLang(state, lang) {
    i18n.locale = lang;
    state.identity.lang = lang;
  },
  setFavorites(state, fav) {
    state.identity.favorites.rules = fav.rules;
    state.identity.favorites.substances = fav.substances;
  },
  setFavoritesRules(state, fav) {
    state.identity.favorites.rules = fav;
  },
  setFavoritesSubstances(state, fav) {
    state.identity.favorites.substances = fav;
  },
  setLastConnection(state) {
    state.identity.last_connection = new Date();
  },
  setCompany(state, company) {
    state.identity.company = company;
  },

  /** Save url before loggin */
  setCurrentUrl(state, url) {
    state.url = url;
  },
  setChanges(state, changes) {
    state.changes = changes;
  },

  /** Save url before loggin */
  setState(state, newState) {
    // state.research = newSate.research;
    state.url = newState.url;
    // state.drawer = newSate.drawer;
  },

  setLastPage(state, lastPage) {
    state.lastPage = lastPage;
  },

  resetLastPage(state) {
    state.lastPage = { name: "", params: {} };
  },

  setCurrentPage(state, currentPage) {
    state.currentPage = currentPage;
  },

  resetCurrentPage(state) {
    state.currentPage = { name: "", params: {} };
  },

  // --------
  // FAV
  // --------

  // Rules selected but not save
  setCurrentRulesFav(state, rules) {
    state.tmp.rulesFav = rules;
  },

  // if diff between rules saved and selected
  setNeedSaveRules(state, value) {
    state.tmp.needSaveRules = value;
  },

  saveRulesFav(state, array) {
    state.identity.favorites.rules = array;
    state.tmp.needSaveRules = false;
    monitore("save rules fav", array)
  },
  
  // if diff between rules saved and selected
  setimportDefaultRulesFav(state, value) {
    state.tmp.importDefaultRulesFav = value;
  },

  addSubFav(state, id) {
    state.identity.favorites.substances.push(id);
  },

  deleteSubFav(state, data) {
    // console.log("index:", data.index)
    // console.log(state.identity.favorites.substances)
    state.identity.favorites.substances.splice(data.index, 1);
    // console.log(state.identity.favorites.substances)
    monitore("Delete sub fav from show", data.id);
  },

  addRuleFav(state, id) {
    state.identity.favorites.rules.push(id);
    monitore("Add sub rule from show", id);
  },

  deleteRuleFav(state, data) {
    // console.log("index:", data.index)
    // console.log(state.identity.favorites.rules)
    state.identity.favorites.rules.splice(data.index, 1);
    // console.log(state.identity.favorites.rules)
    monitore("Delete rule fav from show", data.id);
  },

  // --------
  // Reset
  // --------

  /* Reset state */
  resetState(state) {
    state.user = {};
    state.identity = {
      id: "",
      name: "",
      lang: "fr",
      email: "",
      favorites: {
        rules: [],
        substances: []
      },
      company: "",
    };
    state.tmp = {
      rulesFav: [],
      needSaveRules: false,
    };
    state.url = "";
    state.changes = [];
  },

  resetUser(state) {
    state.identity = {
      id: "",
      name: "",
      lang: "fr",
      email: "",
      favorites: {
        rules: [],
        substances: []
      },
      company: "",
    }
  },

  // --------
  // User Nav
  // --------
  setMultiRulesSelection(state, multiRulesSelection) {
    state.multiRulesSelection = multiRulesSelection;
  },
};

export default mutations;
